function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.32265 24.5812C-0.815517 21.4019 -0.757029 16.275 2.39709 13.1072L13.6629 1.79251C16.0431 -0.598048 19.9119 -0.598259 22.2923 1.79251C24.6495 4.15996 24.6524 7.97978 22.2923 10.35L12.4718 20.2036C10.8683 21.8139 8.24855 21.7914 6.67227 20.1509C5.15367 18.5705 5.20238 16.0654 6.75025 14.5108L14.4704 6.76757C14.8025 6.43461 15.3465 6.42891 15.6856 6.75486L16.9135 7.93501C17.2526 8.26101 17.2584 8.79521 16.9264 9.12818L9.20703 16.8707C8.94214 17.1367 8.92581 17.5788 9.17222 17.8353C9.40703 18.0797 9.77617 18.0837 10.0148 17.844L19.8353 7.99054C20.8887 6.93258 20.8887 5.21012 19.8347 4.15158C18.8041 3.11656 17.1516 3.11603 16.1206 4.15158L4.85467 15.4663C2.98761 17.3415 2.95883 20.3769 4.79071 22.2328C6.61732 24.0834 9.56993 24.0857 11.3999 22.2479L20.641 12.9667C20.9727 12.6334 21.5168 12.6274 21.8562 12.9532L23.0849 14.1325C23.4242 14.4582 23.4304 14.9924 23.0986 15.3257L13.8576 24.6068C10.6578 27.8204 5.48215 27.7823 2.32265 24.5812Z",
  fill: "#4D00B4"
});

var SvgAttachment = function SvgAttachment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAttachment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attachment.61b6a942.svg";
export { ForwardRef as ReactComponent };